import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import uniqueId from 'lodash/uniqueId';

import Form from '../../../../components/Form';
import Input from '../../../../components/Input';
import Label from '../../../../components/Label';
import Checkbox from '../../../../components/Checkbox';
import messages from './messages';

import '../styles.css';

const HousingData = ({ onChange, initialValue }) => {
  const campusHousingCapacityId = uniqueId('campus-housing-capacity');
  const liveOnCampusId = uniqueId('live-on-campus');

  return (
    <React.Fragment>
      <div styleName="field">
        <Label styleName="menu-field-label" as="label" htmlFor={campusHousingCapacityId}>
          <FormattedMessage {...messages.campusHousingCapacity} />
        </Label>
        <Input
          fluid
          type="number"
          min="0"
          id={campusHousingCapacityId}
          value={initialValue.campusHousingCapacity.value}
          onChange={(e, { value }) => {
            onChange(e, {
              campusHousingCapacity: { ...initialValue.campusHousingCapacity, value },
            });
          }}
        />
      </div>
      <div styleName="field">
        <Label styleName="menu-field-label" as="label" htmlFor={liveOnCampusId}>
          <FormattedMessage {...messages.liveOnCampus} />
        </Label>
        <Input
          fluid
          type="number"
          id={liveOnCampusId}
          value={initialValue.liveOnCampus.value}
          onChange={(e, { value }) => {
            onChange(e, {
              liveOnCampus: { ...initialValue.liveOnCampus, value },
            });
          }}
        />
      </div>
      <Form.Field styleName="field">
        <Checkbox
          label={{
            htmlFor: 'freshmanMustLiveOnCampus',
            children: <FormattedMessage {...messages.freshmanMustLiveOnCampus} />,
          }}
          checked={!!Number(initialValue.freshmanMustLiveOnCampus.value)}
          onChange={(e) => {
            // instead of boolean value we put '0' or '1'
            const value = e.target.checked === true ? '1' : '0';
            onChange(e, {
              freshmanMustLiveOnCampus: { ...initialValue.freshmanMustLiveOnCampus, value },
            });
          }}
        />
      </Form.Field>
      <Form.Field styleName="field">
        <Checkbox
          label={{
            htmlFor: 'sophomoresMustLiveOnCampus',
            children: <FormattedMessage {...messages.sophomoresMustLiveOnCampus} />,
          }}
          checked={!!Number(initialValue.sophomoresMustLiveOnCampus.value)}
          onChange={(e) => {
            // instead of boolean value we put '0' or '1'
            const value = e.target.checked === true ? '1' : '0';
            onChange(e, {
              sophomoresMustLiveOnCampus: { ...initialValue.sophomoresMustLiveOnCampus, value },
            });
          }}
        />
      </Form.Field>
      <Form.Field styleName="field">
        <Checkbox
          label={{
            htmlFor: 'juniorsMustLiveOnCampus',
            children: <FormattedMessage {...messages.juniorsMustLiveOnCampus} />,
          }}
          checked={!!Number(initialValue.juniorsMustLiveOnCampus.value)}
          onChange={(e) => {
            // instead of boolean value we put '0' or '1'
            const value = e.target.checked === true ? '1' : '0';
            onChange(e, {
              juniorsMustLiveOnCampus: { ...initialValue.juniorsMustLiveOnCampus, value },
            });
          }}
        />
      </Form.Field>
      <Form.Field styleName="field">
        <Checkbox
          label={{
            htmlFor: 'seniorsMustLiveOnCampus',
            children: <FormattedMessage {...messages.seniorsMustLiveOnCampus} />,
          }}
          checked={!!Number(initialValue.seniorsMustLiveOnCampus.value)}
          onChange={(e) => {
            // instead of boolean value we put '0' or '1'
            const value = e.target.checked === true ? '1' : '0';
            onChange(e, {
              seniorsMustLiveOnCampus: { ...initialValue.seniorsMustLiveOnCampus, value },
            });
          }}
        />
      </Form.Field>
    </React.Fragment>
  );
};

HousingData.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default HousingData;
